import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { useAppSelector } from 'store/hooks';
import { selectIsBreakoutRoom } from 'features/breakout-rooms/breakoutRoomsSlice';
import { useSystemSession } from 'hooks/useSystemSession';
import { canAccessPolls } from 'features/polls/canAccessPolls';

export const usePolls = () => {
  const { hasPermissions } = usePermissions();
  const isFeatureEnabled = useFeatureFlag('polls');

  const isSystemSession = useSystemSession();

  const isBreakoutRoom = useAppSelector(selectIsBreakoutRoom);

  const canManagePolls = hasPermissions(PermissionTypes.managePolls);
  const canTakePolls = hasPermissions(PermissionTypes.takePolls);

  const isFeatureAvailable = canAccessPolls({
    pollsEnabled: isFeatureEnabled,
    canManagePolls,
    canTakePolls,
    isBreakoutRoom,
    isSystemSession,
  });

  return {
    isFeatureAvailable,
    canManagePolls,
    canTakePolls,
  };
};
